__webpack_require__.p = "/nomination/";